var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('div',{class:`${_vm.prefixCls}-carousel`},[_c('Carousel',{attrs:{"carouselData":_vm.swipeList}})],1),_c('notice-announcement'),_c('news-center')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }